// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3n5C3","notes":"Notes_notes__1_jhH"};